import { cn } from '@/common/lib/cn/cn'

export type TagColor = 'yellow' | 'blue' | 'green'

export type TagProps = {
    children: React.ReactNode
    /** @default 'yellow' */
    color?: TagColor
    className?: string
} & Omit<React.HTMLAttributes<HTMLSpanElement>, 'color'>

const tagColorClass: Record<TagColor, string> = {
    yellow: 'text-[#F59E0B] border-[rgba(245,158,11,0.4)] bg-[rgba(245,158,11,0.12)]',
    blue: 'text-[#38BDF8] border-[rgba(56,189,248,0.4)] bg-[rgba(56,189,248,0.12)]',
    green: 'text-[#22C55E] border-[rgba(34,197,94,0.4)] bg-[rgba(34,197,94,0.12)]',
}

export const Tag = ({ children, color = 'yellow', className, ...props }: TagProps) => {
    return (
        <span
            className={cn(
                'inline-flex max-w-full items-center justify-center rounded-[100px] border border-solid px-3 py-1 text-sm font-normal not-italic leading-[140%]',
                tagColorClass[color],
                className
            )}
            {...props}
        >
            {children}
        </span>
    )
}
